import { ListItemButton } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

import { StyledLabel, StyledListItemIcon } from './styles'

interface Props {
	text: string
	linkPath: string
	isExternalUrl?: boolean
	IconComponent: React.ElementType
	onClick?: () => void
}

const ToolbarItem: React.FC<Props> = ({
	text,
	linkPath,
	isExternalUrl,
	IconComponent,
	onClick,
}) => {
	const { pathname } = useLocation()

	const isSameSection = useMemo(
		() =>
			linkPath === '/' ? pathname === linkPath : pathname.startsWith(linkPath),
		[linkPath, pathname]
	)

	return (
		<ListItemButton
			component={isExternalUrl ? 'a' : Link}
			to={isExternalUrl ? undefined : linkPath}
			href={isExternalUrl ? linkPath : undefined}
			target={isExternalUrl ? '_blank' : undefined}
			key={text}
			disableGutters
			onClick={onClick}
		>
			<StyledListItemIcon
				$isSelected={isSameSection}
				data-testid={isSameSection ? 'selected' : 'unselected'}
			>
				<IconComponent />
			</StyledListItemIcon>
			<StyledLabel $isSelected={isSameSection}>{text}</StyledLabel>
		</ListItemButton>
	)
}

export { ToolbarItem }
